import { debugLog } from './utils/logger';

// URLs directas sin proxy
const isDevelopment = process.env.NODE_ENV === 'development';

// Variables de entorno con valores por defecto
export const API_URL = process.env.REACT_APP_API_URL ?? '';
export const PEDIDOS_API_BASE_URL = process.env.REACT_APP_PEDIDOS_API_BASE_URL ?? '';
export const OFERTAS_API_BASE_URL = process.env.REACT_APP_OFERTAS_API_BASE_URL ?? '';

// Logging para debug de variables de entorno
debugLog('🔧 [CONFIG DEBUG] Variables de entorno cargadas:');
debugLog('🔧 [CONFIG DEBUG] NODE_ENV:', process.env.NODE_ENV);
debugLog('🔧 [CONFIG DEBUG] isDevelopment:', isDevelopment);
debugLog('🔧 [CONFIG DEBUG] API_URL:', API_URL || 'NO CONFIGURADO');
debugLog('🔧 [CONFIG DEBUG] PEDIDOS_API_BASE_URL:', PEDIDOS_API_BASE_URL || 'NO CONFIGURADO');
debugLog('🔧 [CONFIG DEBUG] OFERTAS_API_BASE_URL:', OFERTAS_API_BASE_URL || 'NO CONFIGURADO');
/**
 * Genera la URL de la API de cotización con los parámetros requeridos
 */
export function buildPedidosUrl(pedido: string, proveedor: string): string {
  return `${PEDIDOS_API_BASE_URL}?pedido=${pedido}&proveedor=${parseInt(proveedor, 10)}`;
}

/**
 * Genera la URL de la API de cotización con los parámetros requeridos
 */
export function buildOfertasUrl(_pedido: string): string {
  return `${OFERTAS_API_BASE_URL}`;
}
// Variable APP_HOST con logging para debug
export const APP_HOST = process.env.REACT_APP_APP_HOST ?? (isDevelopment ? 'localhost:3000' : '');
debugLog('🔧 [CONFIG DEBUG] APP_HOST:', APP_HOST || 'NO CONFIGURADO');

// Configuración para autenticación ultra segura
export const ULTRA_SECURE_BACKEND_URL = process.env.REACT_APP_ULTRA_SECURE_BACKEND_URL ?? 'http://localhost:3001';

// Logging para configuración ultra segura
debugLog('🔧 [CONFIG DEBUG] Ultra Secure configuration:');
debugLog('🔧 [CONFIG DEBUG] ULTRA_SECURE_BACKEND_URL:', ULTRA_SECURE_BACKEND_URL || 'NO CONFIGURADO');
